import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SpinnerService {
  private spinnerSubject = new BehaviorSubject<boolean>(false);
  spinner$ = this.spinnerSubject.asObservable();
  private activeRequests = 0;
  private spinnerTimeout: any;

  show(): void {
    this.activeRequests++;
    if (this.activeRequests === 1) {
      this.spinnerTimeout = setTimeout(() => {
        this.spinnerSubject.next(true);
      }, 500);
    }
  }

  hide(): void {
    this.activeRequests--;
    if (this.activeRequests === 0) {
      clearTimeout(this.spinnerTimeout);
      this.spinnerSubject.next(false);
    }
  }
}
